import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    Paper,
    Container, Modal,
    TextField,
    Button,
    Box,
    Snackbar,
    Alert
} from '@mui/material';

const AddVehicleType = () => {
    const navigate = useNavigate();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [vehicleType, setVehicleType] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const handleReset = () =>{
        setVehicleType("");
    }

    const handleSave = async () => {
        if (!vehicleType.trim()) {
            showSnackbar("Vehicle type name is required", "error");
            return;
        }

        const apiUrl = process.env.REACT_APP_BASE_URL;
        const queryParam = encodeURIComponent(vehicleType.trim());

        try {
            const response = await fetch(`${apiUrl}/Transportation/VehicleType?vehicleType=${queryParam}`, {
                method: 'POST',
                headers: {
                    Authorization: sessionStorage.getItem('token'),
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to add vehicle type");
            }

           setShowSuccessModal(true);

        } catch (error) {
            console.error("Error saving vehicle type:", error);
            showSnackbar(error.message || "Failed to save vehicle type", "error");
        }
    };

    const showSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    return (
        <Container>
            {/* Header */}
             <Box display="flex" flexDirection="column" alignItems="center">
          <Box
          sx={{
            backgroundColor: '#0B1F40', // dark navy blue
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
           width: "900px",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff',  fontWeight: 'bold' }}>
        Add New Vehicle Type
      </Typography> </Box>

            {/* Form Card */}
          
                <Paper elevation={3} style={{ padding: 24, borderRadius: 8,  width: "900px", marginTop:6 }}>
                    <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                        <Typography variant="h6" gutterBottom>
                            Vehicle Type Name
                        </Typography>

                        <TextField
                            fullWidth
                            required
                            label="eg., Bus, Van, Car"
                            variant="outlined"
                            value={vehicleType}
                            onChange={(e) => setVehicleType(e.target.value)}
                            sx={{ mt: 2 }}
                        />

                        {/* Buttons */}
                        <Box mt={3} display="flex" gap={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: "#0B1F3D",
                                    textTransform: "uppercase",
                                    '&:hover': { backgroundColor: "#0A1A32" }
                                }}
                            >
                                SAVE
                            </Button>
                            <Button
                                variant="outlined"
                                color='error'
                                onClick={handleReset}
                                sx={{
                                    textTransform: "uppercase",
                                   
                                  
                                }}
                            >
                                RESET
                            </Button>
                        </Box>
                    </form>
                </Paper>
          </Box>

           <Modal
  open={showSuccessModal}
  onClose={() => setShowSuccessModal(false)}
  aria-labelledby="success-modal-title"
  aria-describedby="success-modal-description"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
      <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
        Vehicle Added ✅
      </Typography>
    </Box>

    {/* Content */}
    <Box sx={{ padding: '20px' }}>
      <Typography id="success-modal-description" sx={{ mb: 2 }}>
        The Vehicle Type has been added successfully.
      </Typography>

      {/* Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          onClick={() => {
            setShowSuccessModal(false);
            navigate(-1); // go back after closing modal
          }}
          variant="contained"
          color="primary"
        >
          OK
        </Button>
      </Box>
    </Box>
  </Box>
</Modal>

           
        </Container>
    );
};

export default AddVehicleType;
